<script setup>
import { ref, computed, onMounted, reactive, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { supabase } from '@/supabase'



import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import { template } from 'lodash'


const store = useStore()
const router = useRouter();
const usuario = computed(() => store.state.userSession.user.idU)
const aula = computed(() => store.state.aula)
const grupos = ref([])
const notasLiberadas = ref(false)
const rubricas = ref([])
const avaliacoes = ref()
const notas = ref()
const carregando = ref(true)
const visibilidadeRubricaAvaliacao = ref(true)
const formularios = ref()
const screenWidth = ref(window.innerWidth);
const screenHeight = ref(window.innerHeight);

const isIphone = ref(false);



onMounted(() => {
    isIphone.value = /iPhone/.test(navigator.userAgent) && !window.MSStream;

    document.addEventListener('visibilitychange', () => {
        if (document.hidden || document.webkitHidden) {
            if (isIphone.value == true) {
                modalFormulario.value = false;
                // fechar o modal com o modalFormularioIphone
                modalFormularioIphone.value = false
                encerrarAvaliacao();
                
            } else {
                if (isFullScreen.value == true) {
                    isFullScreen.value = false;
                    encerrarAvaliacao();
                    modalFormulario.value = false;
                }
            }

        }

    });

    document.addEventListener('fullscreenchange', checkFullScreen);

    carregarDados();
    
});
async function carregarDados() {
    window.addEventListener('resize', updateDimensions);
    await verificarNotasLiberadas();
    await listarRubrica();
    await listarNotas();
    //await listarAvaliacoesPercentuais()
    carregando.value = false

}
onUnmounted(() => {
    window.removeEventListener('resize', updateDimensions);
});
function updateDimensions() {
    screenWidth.value = window.innerWidth;
    screenHeight.value = window.innerHeight;
}


async function verificarNotasLiberadas() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('planos_aulas')
        .select('plano, aula, visivelParaOEstudante')
        .eq('plano', aula.value.idPlano)
        .eq('aula', aula.value.idDaAula)
        .single()
    if (error) {
        alert('Ocorreu um erro ao carregar as aulas: ' + error.message)
        store.dispatch('updateLoading', false)
        return
    }
    notasLiberadas.value = data.visivelParaOEstudante
    if (notasLiberadas.value) {
        visibilidadeRubricaAvaliacao.value = false
    }
    store.dispatch('updateLoading', false)
}


async function listarRubrica() {
    const { data, error } = await supabase
        .from('planos_avaliacoes')
        .select('*, criterios_rubrica(criterio)')
        .eq('plano', aula.value.idPlano)
        .order('criterio', { ascending: true })
        .eq('tipo', '1')

    rubricas.value = data
    let array = []
    data.forEach(rubrica => {
        array.push(rubrica.id)
    })

    avaliacoes.value = array

}

async function listarAvaliacoesPercentuais() {
    console.log(usuario.value)
    const { data, error } = await supabase
        .from('planos_avaliacoes')
        .select('*, planos_notas(estudante,avaliacao_forms_encerrada, id)')
        .eq('plano', aula.value.idPlano)
        .eq('tipo', '2')
        .eq('planos_notas.estudante', usuario.value)
    console.log('Valor')
    console.log(data)
    let array = []
    data.forEach(form => {
        array.push({ 'id': form.id, 'forms_id': form.forms_id, 'tipo': form.tipo, 'titulo': form.titulo, 'responder_uri': form.responder_uri, 'avaliacao_forms_encerrada': form.planos_notas[0].avaliacao_forms_encerrada, idAvaliacao: form.planos_notas[0].id })
    })

    formularios.value = array


    console.log(formularios.value)
}

async function listarNotas() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('planos_notas')
        .select('*')
        .eq('estudante', usuario.value)
        .in('avaliacao', avaliacoes.value)

    if (error) {
        alert('Ocorreu um erro ao carregar as aulas: ' + error.message)
        store.dispatch('updateLoading', false)
        return
    }

    let array = []
    rubricas.value.forEach(rubrica => {
        data.forEach(nota => {
            if (nota.avaliacao == rubrica.id && nota.nota > 0 && nota.nota < 200) {
                array.push({ rubrica: rubrica, nota: nota })
            }
        })
    })
    notas.value = array

    store.dispatch('updateLoading', false)
}

function definirIcone(criterio) {
    switch (criterio) {
        case 1:
            return `pi-building`
        case 2:
            return `pi-wrench`
        case 3:
            return `pi-pencil`
        case 4:
            return `pi-mobile`
        case 5:
            return `pi-users`
        case 6:
            return `pi-car`
    }

}

function definirClassesNivelNota(nota) {
    switch (nota) {
        case 90:
            return 'pi-check bg-blue-400'
        case 100:
            return 'pi-check bg-green-400'
        case 60:
            return 'pi-exclamation-circle bg-yellow-400'
        case 10:
            return 'pi-exclamation-circle bg-red-400'
        case 1:
            return 'pi-exclamation-circle bg-red-400'
    }
}


const dadosFormurmulario = ref()
const isFullScreen = ref(false)
const modalFormulario = ref(false)
const modalFormularioIphone = ref(false)

function abrirFormulario(data) {
    if (data.avaliacao_forms_encerrada) {
        alert('Essa avaliação foi encerrada para você, porque você saiu de tela cheia ou alternou de aplicativo. Converse com o professor.')
        return
    }
    dadosFormurmulario.value = data
    modalFormulario.value = true
}



const checkFullScreen = () => {
    if (!document.fullscreenElement) {
        isFullScreen.value = false;
        encerrarAvaliacao()
        modalFormulario.value = false;
    }
};

const openFullScreen = () => {
    console.log(isIphone.value)
    if (isIphone.value == true) {
        modalFormularioIphone.value = true
        
    } else {
        document.documentElement.requestFullscreen().then(() => {
            isFullScreen.value = true;
            const screenHeight = window.screen.height;
            const windowHeight = window.innerHeight;

            // if (windowHeight < screenHeight ) {
            //     console.log('É diferente o valor')
            // }
        }).catch((err) => {
            alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
        });

    }


}

const closeFullScreen = () => {
    if (document.fullscreenElement != null) {
        document.exitFullscreen().then(() => {
            isFullScreen.value = false;
            encerrarAvaliacao();
            modalFormulario.value = false;
        }).catch((err) => {
            console.error(`Error attempting to disable full-screen mode: ${err.message} (${err.name})`);
        });
    }
};

function encerrarAvaliacaoIphone(){
    modalFormulario.value = false
    modalFormularioIphone.value = false
    encerrarAvaliacao()
}

async function encerrarAvaliacao() {
    const { data, error } = await supabase
        .from('planos_notas')
        .update({ avaliacao_forms_encerrada: true })
        .eq('id', dadosFormurmulario.value.idAvaliacao)
    if (error) {
        
    }

    dadosFormurmulario.value.avaliacao_forms_encerrada = true
}

function gerarIndicesAcordeon(valorMaximo){
    let array = []
    for (let i = 0; i <= valorMaximo; i++) {
        array.push(i)
    }
    return array
}

</script>


<template>
    <div class="container py-8 fadein animation-duration-500" v-if="!carregando">
        <!-- <div v-if="formularios.length > 0 && !notasLiberadas">
            <div class="my-3 font-normal color-text text-lg  md:my-5">Atividades</div>
            <div @click="abrirFormulario(form)" v-for="form in formularios" :key="form.id"
                class="bg-white shadow-1 border-round-sm p-4 mb-4">
                <div class="flex gap-3">
                    <div><i class="pi pi-pencil"></i></div>
                    <div class="text-color font-bold">{{ form.titulo }}</div>
                </div>
            </div>
        </div> -->
        <div v-if="notasLiberadas" class="mb-5">
            <div class="my-3 font-normal color-text text-lg  md:my-5">Meu desempenho</div>
            <Accordion :multiple="true" :activeIndex="gerarIndicesAcordeon(notas.length)">
                <AccordionTab v-for="nota in notas" :key="nota.nota.avaliacao">
                    <template #header>
                        <span class="flex align-items-center gap-2  justify-content-between w-full">
                            <div class="flex flex-column gap-1">
                                <span v-if="nota.rubrica.titulo !== ''" class="font-bold">{{ nota.rubrica.titulo
                                    }}</span>
                                <span v-else class="font-bold">{{ nota.rubrica.criterios_rubrica.criterio }}</span>
                                <span class="text-sm font-normal" v-if="nota.nota.comentario_para_estudante != ''">Ver
                                    comentário do
                                    professor</span>
                            </div>
                            
                            <div :class="`pi text-white border-circle p-2 ${definirClassesNivelNota(nota.nota.nota)}`">
                            </div>
                        </span>

                    </template>
                    <div v-if="nota.nota.nota == 100" class="flex flex-column gap-3">
                        <div>Você excedeu as expectativas nesse critério, parabéns! Conforme a rubrica da atividade
                        </div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel4 }}</div>

                        <div v-if="nota.nota.comentario_para_estudante != ''" class="flex flex-column gap-2">
                            <div class="font-semibold text-sm mt-3 ">Comentário do professor</div>
                            <div class="surface-100 p-3 round text-sm border-round-md">{{
                                nota.nota.comentario_para_estudante }}</div>
                        </div>
                    </div>
                    <div v-else-if="nota.nota.nota == 90" class="flex flex-column gap-3">
                        <div>Você atingiu plenamente esse critério. Conforme a rubrica de avaliação da atividade
                        </div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel3 }}</div>

                        <div v-if="nota.nota.comentario_para_estudante != ''" class="flex flex-column gap-2">
                            <div class="font-semibold text-sm mt-3 ">Comentário do professor</div>
                            <div class="surface-100 p-3 round text-sm border-round-md">{{
                                nota.nota.comentario_para_estudante }}</div>
                        </div>
                    </div>
                    <div v-else-if="nota.nota.nota == 60" class="flex flex-column gap-3">
                        <div>Você não se saiu tão bem nesse critério. Conforme a rubrica de avaliação da atividade
                        </div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel2 }}</div>
                        <div>Isso é menos do que o necessário. Para atingir plenamente esse critério você precisava pelo
                            menos o seguinte:</div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel3 }}</div>

                        <div v-if="nota.nota.comentario_para_estudante != ''" class="flex flex-column gap-2">
                            <div class="font-semibold text-sm mt-3 ">Comentário do professor</div>
                            <div class="surface-100 p-3 round text-sm border-round-md">{{
                                nota.nota.comentario_para_estudante }}</div>
                        </div>
                    </div>
                    <div v-else-if="nota.nota.nota == 10" class="flex flex-column gap-3">
                        <div>Você atingiu minimamente esse critério. Conforme a rubrica de avaliação da atividade
                        </div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel1 }}</div>
                        <div>Isso é menos do que o necessário. Para atingir plenamente esse critério você precisava pelo
                            menos o seguinte:</div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel3 }}</div>

                        <div v-if="nota.nota.comentario_para_estudante != ''" class="flex flex-column gap-2">
                            <div class="font-semibold text-sm mt-3 ">Comentário do professor</div>
                            <div class="surface-100 p-3 round text-sm border-round-md">{{
                                nota.nota.comentario_para_estudante }}</div>
                        </div>
                    </div>
                    <div v-else-if="nota.nota.nota == 1" class="flex flex-column gap-3">
                        <div>Você não fez o que era necessário para ser avaliado nesse critério. </div>
                        <div>O critério era o seguinte:</div>
                        <div class="surface-100 p-3 round text-sm border-round-md">{{ nota.rubrica.nivel3 }}</div>

                        <div v-if="nota.nota.comentario_para_estudante != ''" class="flex flex-column gap-2">
                            <div class="font-semibold text-sm mt-3 ">Comentário do professor</div>
                            <div class="surface-100 p-3 round text-sm border-round-md">{{
                                nota.nota.comentario_para_estudante }}</div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
            <Button label="Ver rubrica de avaliação" rounded outlined @click="visibilidadeRubricaAvaliacao = true"
                class="mt-3 w-full" />
        </div>


        <div v-if="visibilidadeRubricaAvaliacao" class="fadein animation-duration-500">
            <div class="my-3 font-normal color-text text-lg  md:my-5">Rubrica de avaliação </div>
            <Accordion :multiple="false" :activeIndex="0">
                <AccordionTab header="Plenamente desenvolvido">
                    <div class="p-0 md:p-4">
                        <div class="text-color mb-3 md:mb-5">Veja o que você precisa para atingir plenamente os
                            objetivos
                            dessas
                            aulas em cada um dos critérios que será avaliado.</div>
                        <div v-for="rubrica in rubricas" :key="rubrica.id">
                            <div v-if="rubrica.nivel3 != ''" class="flex align-items-top mb-3 gap-3 md:mb-5 md:gap-5">
                                <div>
                                    <div class="text-color font-semibold">{{ rubrica.criterios_rubrica.criterio }}</div>
                                    <div class="text-color-secondary font-light text-sm">{{ rubrica.titulo }}</div>
                                    <div class="text-color-secondary font-light text-sm">{{ rubrica.nivel3 }}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </AccordionTab>
                <AccordionTab header="Excede expectativas">
                    <div class="p-0 md:p-4">
                        <div class="text-color mb-3 md:mb-5">Veja como ir além e aprofundar seus conhecimentos nessas
                            aulas.
                        </div>
                        <div v-for="rubrica in rubricas" :key="rubrica.id">
                            <div v-if="rubrica.nivel4 != ''" class="flex align-items-top mb-3 gap-3 md:mb-5 md:gap-5">
                                <div>
                                    <div class="text-color font-semibold">{{ rubrica.criterios_rubrica.criterio }}</div>
                                    <div class="text-color-secondary font-light text-sm">{{ rubrica.nivel4 }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionTab>
                <AccordionTab header="Parcialmente desenvolvido">
                    <div class="p-0 md:p-4">
                        <div class="text-color mb-3 md:mb-5">Procure evitar esse nível de aprendizagem dos critérios,
                            pois
                            ele
                            atende apenas parcialmente os objetivos
                        </div>
                        <div v-for="rubrica in rubricas" :key="rubrica.id">
                            <div v-if="rubrica.nivel2 != ''" class="flex align-items-top mb-3 gap-3 md:mb-5 md:gap-5">
                                <div>
                                    <div class="text-color font-semibold">{{ rubrica.criterios_rubrica.criterio }}</div>
                                    <div class="text-color-secondary font-light text-sm">{{ rubrica.nivel2 }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionTab>
                <AccordionTab header="Minimamente desenvolvido">
                    <div class="p-0 md:p-4">
                        <div class="text-color mb-3 md:mb-5">Procure evitar esse nível de aprendizagem dos critérios,
                            pois
                            ele
                            atende apenas minimamente os objetivos
                        </div>
                        <div v-for="rubrica in rubricas" :key="rubrica.id">
                            <div v-if="rubrica.nivel1 != ''" class="flex align-items-top mb-3 gap-3 md:mb-5 md:gap-5">
                                <div>
                                    <div class="text-color font-semibold">{{ rubrica.criterios_rubrica.criterio }}</div>
                                    <div class="text-color-secondary font-light text-sm">{{ rubrica.nivel1 }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
        </div>
    </div>
    <Dialog v-model:visible="modalFormulario" modal header="Avaliação" :style="{ width: '50rem' }"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <div v-if="modalFormulario">
            <div class="mb-3 ">Ao iniciar a avaliação, seu dispositivo vai ficar em tela cheia. Você não deve sair de
                tela
                cheia, alternar
                entre abas do navegador ou aplicativos até finalizá-la.</div>
            <Button @click="openFullScreen" label="Inciar Avaliação" />

        </div>
    </Dialog>

    <Dialog v-model:visible="modalFormularioIphone" :closable=false modal :style="{ width: '100%', height: '100%' }">
        <template #header>
            <div class="flex justify-content-between w-full align-items-center">
                <div class="text-xl font-semibold">Avaliação</div>
                <div><Button label="Fechar" @click="encerrarAvaliacaoIphone" /></div>
            </div>
        </template>
        <div v-if="dadosFormurmulario">
            <iframe
                :src="`https://docs.google.com/forms/d/e/${dadosFormurmulario.responder_uri}/viewform?embedded=true`"
                :width="screenWidth - 40" :height="screenHeight + 900" frameborder="0" marginheight="0"
                marginwidth="0">Carregando…</iframe>
        </div>
    </Dialog>



    <div class="fullscreen-wrapper" v-if="isFullScreen">
        <div class="header border-bottom-1 border-200 z-3 flex justify-content-between">
            <div class="color-text text-xl flex align-items-center">
                Avaliação
            </div>
            <div>
                <Button @click="closeFullScreen" icon="pi pi-times" severity="secondary" text rounded
                    aria-label="Cancel" />
            </div>
        </div>
        <div v-if="dadosFormurmulario" class="mt-7">
            <iframe
                :src="`https://docs.google.com/forms/d/e/${dadosFormurmulario.responder_uri}/viewform?embedded=true`"
                :width="screenWidth" :height="screenHeight - 80" frameborder="0" marginheight="0"
                marginwidth="0">Carregando…</iframe>
        </div>
    </div>
</template>
<style>
.fullscreen-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #FFF;
    z-index: 1900;

}

.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 10px;
    box-sizing: border-box;
    background-color: #fff;
}
.form-modal .p-dialog .p-dialog-content {
    padding: 0px;
}
</style>